export const ImageIcon = () => (
  <svg
    width={402}
    height={402}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 2.25H16V1.125C16 0.50625 15.55 0 15 0H1C0.45 0 0 0.50625 0 1.125V14.625C0 15.2438 0.45 15.75 1 15.75H2V16.875C2 17.4938 2.45 18 3 18H17C17.55 18 18 17.4938 18 16.875V3.375C18 2.75625 17.55 2.25 17 2.25ZM2 3.375V14.625H1.002L1 14.6228V1.12725L1.002 1.125H14.998L15 1.12725V2.25H3C2.45 2.25 2 2.75625 2 3.375ZM17 16.8728L16.998 16.875H3.002L3 16.8728V3.37725L3.002 3.375H16.998L17 3.37725V16.8728Z"
      fill="#6883BE"
    />
    <path
      d="M15 6.18753C14.9999 6.63523 14.8417 7.06453 14.5602 7.381C14.2787 7.69747 13.897 7.87518 13.499 7.87503C13.101 7.87488 12.7194 7.69689 12.4381 7.38021C12.1568 7.06353 11.9989 6.6341 11.999 6.1864C11.9991 5.7387 12.1573 5.30939 12.4388 4.99293C12.7203 4.67646 13.102 4.49875 13.5 4.4989C13.898 4.49905 14.2796 4.67704 14.5609 4.99372C14.8422 5.3104 15.0001 5.73982 15 6.18753ZM16 15.75H4V13.5L7.5 6.75003L11.5 12.375H12.5L16 9.00003V15.75Z"
      fill="#6883BE"
    />
  </svg>
);
